<template>
  <SSelect v-model="model">
    <SSelectTrigger class="w-full">
      <SSelectValue
        :placeholder="placeholder ?? t('select.person-status.title')"
      />
    </SSelectTrigger>
    <SSelectContent>
      <SSelectItem
        v-for="item in statuses"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </SSelectItem>
    </SSelectContent>
  </SSelect>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import {
  SSelect,
  SSelectContent,
  SSelectItem,
  SSelectTrigger,
  SSelectValue,
} from "@smeetz/ui-core";

const { t, te } = useI18n({ useScope: "global" });

const model = defineModel<string>();

defineProps<{ placeholder?: string }>();

const statuses = computed(() => {
  const statusesAll = [
    { value: "1", label: t("select.person-status.mr") },
    { value: "2", label: t("select.person-status.mrs") },
    { value: "3", label: t("select.person-status.dr") },
    { value: "5", label: t("select.person-status.prof") },
  ];

  if (te("select.person-status.ms")) {
    statusesAll.push({ value: "4", label: t("select.person-status.ms") });
  }

  return statusesAll;
});
</script>
